import { useEffect, useState } from "react";

import Router, { useRouter } from "next/router";
import { getPackageByPeriod } from "src/pages/api/pricing";
import { checkTenantEmail } from "src/pages/api/user";
import PricingPackage from "@/admin/organisms/Package";
import Button from "@/admin/atoms/Button";
import AdminOnboardingBottomArea from "../../AdminOnboardingBottomArea";
import LandingPageNavArea from "../LandingPageNavArea";
import styles from "./LandingPageBackground.module.css";

// import ChoosePlan from "../../SignUpBackground/ChoosePlan";

function LandingPageBackground(): JSX.Element {
  const router = useRouter();
  const [userEmail, setUserEmail] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [period, setPeriod] = useState("monthly");
  const [pricingPackage, setPricingPackage] = useState([]);
  function handleWindowSizeChange() {
    setIsMobile(window.innerWidth <= 768);
  }

  useEffect(() => {
    getPackageByPeriod(period).then((response: any) => {
      setPricingPackage(response.data.data[0]);
    });
  }, [period]);

  useEffect(() => {
    if (window.Tawk_API) {
      window.Tawk_API.showWidget();
      window.Tawk_API.minimize();
    }
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <div className={styles.frame}>
      <LandingPageNavArea showDesktopMenu />

      <div className="w-full flex  justify-center ">
        <div className={styles.secondLayerFrame}>
          <div className={styles.secondLayerFrameLeftPanel}>
            <div className={styles.careerSupportFrame}>
              <img
                src="/images/landing-page-image/Star1.svg"
                className="w-[14px] h-[14px]"
                alt="Top rated learning management"
              />
              <span className="text-[#FC4409] ">
                Top Rated Learning Management System
              </span>
            </div>
            <h1 className={styles.header1}>
              Helping Training Teams Drive Engagement and Measure Impact <br />{" "}
              Effectively.
            </h1>
            <h2 className={styles.header2}>
              {`Accelerate your team's skill development with our all-encompassing
              learning solutions, crafted to meet your organization's unique
              needs.`}
            </h2>
            <div className="w-full">
              <div className={styles.searchFrame}>
                <input
                  type="text"
                  placeholder="Enter Email here"
                  className="w-[70%] outline-none pl-6 phone:pl-4 bg-transparent h-[90%] text-[#555555]"
                  onChange={({ target }) => {
                    setUserEmail(target.value);
                  }}
                />
                <Button
                  variant="landing-primary"
                  onClick={() => {
                    checkTenantEmail(userEmail).then((tenantResponse) => {
                      console.log("yath:", tenantResponse);
                      if (tenantResponse.data.message === "email exist") {
                        Router.push({
                          pathname: "/admin-portal/onboarding/sign-in",
                          query: {
                            userEmail: userEmail,
                          },
                        });
                      } else {
                        Router.push({
                          pathname: "/sign-up",
                          query: {
                            userEmail: userEmail,
                          },
                        });
                      }
                    });
                  }}
                >
                  <p className=" py-4">Sign up</p>
                </Button>
              </div>
              <div className="invisible w-0 h-0 phone:visible phone:w-full phone:h-auto phone:mt-8">
                <img
                  alt="cover pic"
                  src="/images/landing-page-image/landing-page-top-pic.svg"
                  width="100%"
                  height="100%"
                />
              </div>
              <div className={styles.subEmailFrame}>
                <div className="w-[144px] h-full phone:w-full phone:mt-4 phone:flex phone:justify-center">
                  {/* <img
                    alt=""
                    src="/images/landing-page-image/Landing-page-User-Avatar.svg"
                  /> */}
                </div>
                <div className="h-full flex flex-col justify-between phone:w-full phone:justify-start gap-y-4 ml-6 phone:ml-0 ">
                  {/* <span className="phone:w-full phone:flex phone:justify-center">
                    <img
                      alt=""
                      src="/images/landing-page-image/landing-page-stars.svg"
                    />
                  </span>
                  <span className="text-[#555555] phone:w-full phone:flex phone:justify-center">
                    Empowering over 10,000 learners
                  </span> */}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.secondLayerFrameRightPanel}>
            <div className="w-full h-full flex justify-end">
              <img
                alt="cover pic"
                src="/images/landing-page-image/landing-page-top-pic.svg"
                width="88%"
                height="100%"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="w-full mt-20 phone:px-2 phone:mt-2 text-center text-xl text-[#555555] phone:text-base">
        Supporting Industry Leaders in Delivering Quality Training Worldwide
      </div>
      <div className="w-full h-[40px] phone:h-auto mt-[40px] flex justify-center px-36 phone:px-2 ">
        <div className="w-full h-full flex  phone:gap-y-8  justify-between phone:justify-evenly phone:flex-wrap ">
          <img
            alt="cherishConsulting"
            src="/images/landing-page-image/cherishConsulting-icon.svg"
            className="phone:w-[185px] phone:h-[28px]"
          />
          <img
            alt="ciphertainment"
            src="/images/landing-page-image/ciphertainment-Icon.svg"
            className="phone:w-[154px] phone:h-[28px]"
          />
          <img
            alt="crestlearn"
            src="/images/landing-page-image/crestlearn-Icon.svg"
            className="phone:w-[130px] phone:h-[28px]"
          />
          <img
            alt="akrgrow"
            src="/images/landing-page-image/akrgrow-Icon.svg"
            className="phone:w-[164px] phone:h-[28px]"
          />
        </div>
      </div>

      <div
        id="choose-a-planscreen"
        className="w-full bg-[#F6F5FFCC] mt-20 px-[80px] phone:px-6 py-[80px] phone:py-[32px] flex justify-center flex-col items-center"
      >
        <div className="text-[#262626] text-center font-bold text-[48px] phone:text-[30px]  ">
          Flexible Plans for Every Training Organization
        </div>
        <div className="text-[20px] text-[#555555] phone:text-[14px] text-center phone:mt-4">
          Find the perfect plan that aligns with your budget and goals, designed
          to maximize value and scalability for your organization.
        </div>

        <div className="py-12 text-sm  w-full flex place-content-center">
          <div className="w2/4 phone:w-5/6 h-12 flex rounded-full justify-between text-white shadow-lg bg-[#F6F5FFCC] border inset-shadow-sm ">
            <div
              role="button"
              tabIndex={0}
              onKeyDown={() => {
                setPeriod("monthly");
              }}
              onClick={() => {
                setPeriod("monthly");
              }}
              className={
                period === "monthly"
                  ? "h-5 self-center flex place-content-center h-full bg-blue500 rounded-full px-6 py-3 "
                  : "h-5 self-center flex place-content-center h-full text-black rounded-full px-6 py-3 "
              }
            >
              <div className="self-center">MONTHLY</div>
            </div>
            <div
              className={
                period === "yearly"
                  ? "h-5 self-center flex place-content-center h-full bg-blue500 rounded-full px-6 py-3 "
                  : "h-5 self-center flex place-content-center h-full text-black rounded-full px-6 py-3 "
              }
            >
              <div
                role="button"
                tabIndex={0}
                onKeyDown={() => {
                  setPeriod("yearly");
                }}
                onClick={() => {
                  setPeriod("yearly");
                }}
                className="self-center px-1 flex gap-x-1 text-center"
              >
                <div className="self-center">YEARLY</div>
                <div className="w-3/4 px-[6px] self-center rounded-full text-xs bg-primaryOne50 text-primaryOne500">
                  15% Off
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full pt-20 phone:w-full phone:pt-12 space-y-0 phone:space-y-8 flex flex-row phone:flex-col gap-x-8 phone:gap-x-0">
          {/* <ChoosePlan period={period} /> */}
          {pricingPackage.map((pkg: any) => (
            <div className="">
              <PricingPackage
                name={pkg.name}
                id={pkg.id}
                cost={pkg.cost}
                numberOfUsers={pkg.number_of_users}
                summary={pkg.summary}
                period={pkg.period}
                variant="potrait"
                showButton
              />
            </div>
          ))}
        </div>
      </div>

      <div className={styles.thirdLayerFrame}>
        <div className="w-full h-[462px] phone:h-auto">
          <div className="w-full text-center text-white text-2xl font-bold leading-[150%]">
            Why MyEdVault Is Your Training Solution
          </div>
          <div className="w-full text-lg phone:text-[14px] text-white mt-4 text-center italic px-[80px] phone:px-4 leading-[150%]">
            {`From creating courses to tracking progress and organizing events,
            MyEdVault suite of tools ensures your organization's learning
            experience is smooth and effective.`}
          </div>

          <div className="invisible w-0 h-0 phone:visible phone:w-full phone:h-auto phone:mt-14 flex flex-col gap-y-4">
            <img
              alt="contentFrame1Mobile"
              src="/images/landing-page-image/contentFrame1Mobile.svg"
              className="w-full"
            />
            <img
              alt="contentFrame2Mobile"
              src="/images/landing-page-image/contentFrame2Mobile.svg"
              className="w-full"
            />
            <img
              alt="contentFrame3Mobile"
              src="/images/landing-page-image/contentFrame3Mobile.svg"
              className="w-full"
            />
            <img
              alt="contentFrame4Mobile"
              src="/images/landing-page-image/contentFrame4Mobile.svg"
              className="w-full"
            />
          </div>

          <div className="w-full h-[303px] mt-14 flex justify-between phone:w-0 phone:h-0 phone:invisible">
            <img
              alt="contentFrame1"
              src="/images/landing-page-image/contentFrame1.svg"
              className="w-1/4"
            />
            <img
              alt="contentFrame2"
              src="/images/landing-page-image/contentFrame2.svg"
              className="w-1/4"
            />
            <img
              alt="contentFrame3"
              src="/images/landing-page-image/contentFrame3.svg"
              className="w-1/4"
            />
            <img
              alt="contentFrame4"
              src="/images/landing-page-image/contentFrame4.svg"
              className="w-1/4"
            />
          </div>
        </div>
      </div>

      <div className={styles.fourthLayerFrame}>
        <div className="w-full h-[134px] phone:h-auto  flex phone:flex-col">
          <div className="font-bold text-[56px] phone:text-[24px] leading-[120%] w-[70%] phone:w-full">
            <span className="text-[#FC4409]">Unmatched</span> Training <br />
            Experiences
          </div>
          <div className="w-[30%] phone:w-full text-lg phone:text-[14px] leading-[150%] pt-4">
            Master your training programs with effortless control, precise
            customization, and breakthrough results that drive success.
          </div>
        </div>
        <div className="w-full h-[399px] phone:h-auto phone:gap-y-4 phone:flex-col flex justify-between mt-6">
          <div className="h-full w-[38%] phone:w-full  border-2 border-[#DEDEDE] shadow-md rounded-[12px]  flex flex-col  p-6">
            <img
              alt="user manager"
              src={
                isMobile
                  ? "/images/landing-page-image/landing-page-manage-user-picMobile.svg"
                  : "/images/landing-page-image/landing-page-manage-user-pic.svg"
              }
              className={styles.testingStyle}
            />
            <div className="w-full text-[24px] phone:text-[20px] font-medium  leading-[120%] text-[#262626]">
              Manage users effortlessly.
            </div>
            <div className="text-[#7B7B7B] text-[14px] mt-[20px]">
              Assign roles, and streamline access to content, ensuring a smooth
              learning experience for everyone.
            </div>
          </div>
          <div className="h-full w-[60%] phone:w-full border-2 border-[#DEDEDE] rounded-[12px] flex flex-col p-6 shadow-md">
            <img
              alt="organize"
              src={
                isMobile
                  ? "/images/landing-page-image/landing-page-organize-taskMobile.svg"
                  : "/images/landing-page-image/landing-page-organize-task.svg"
              }
              className={styles.testingStyle}
            />

            <div className="w-full text-[24px] phone:text-[20px]  font-medium leading-[120%] text-[#262626]">
              Organize tasks and quizzes.
            </div>
            <div className="text-[#7B7B7B] text-[14px] mt-[20px]">
              Easily design courses with multimedia, quizzes, and tasks to
              create personalized learning experiences for your team.
            </div>
          </div>
        </div>

        <div className="w-full h-[399px] phone:h-auto phone:flex-col phone:gap-y-4 flex justify-between mt-6">
          <div className="h-full w-[60%] phone:w-full border-2 shadow-md border-[#DEDEDE] rounded-[12px] flex flex-col p-6">
            <img
              alt="share video"
              src={
                isMobile
                  ? "/images/landing-page-image/landing-page-share-videosMobile.svg"
                  : "/images/landing-page-image/landing-page-share-videos.svg"
              }
              className={styles.testingStyle}
            />
            <div className="text-[24px] phone:text-[20px]  font-medium leading-[120%] text-[#262626]">
              Create and Share videos seamlessly.
            </div>
            <div className="text-[#7B7B7B] text-[14px] mt-[20px]">
              Organize and deliver video lessons in multiple formats, accessible
              anytime, anywhere. Customize playback to enhance learning
              engagement.
            </div>
          </div>
          <div className="h-full w-[38%] phone:w-full shadow-md border-2 border-[#DEDEDE] rounded-[12px]  flex flex-col p-6">
            <img
              alt="plan and run"
              src={
                isMobile
                  ? "/images/landing-page-image/landing-page-plan-and-runMobile.svg"
                  : "/images/landing-page-image/landing-page-plan-and-run.svg"
              }
              className={styles.testingStyle}
            />
            <div className="text-[24px] phone:text-[20px]  font-medium leading-[120%] text-[#262626]">
              Plan and run events.
            </div>
            <div className="text-[#7B7B7B] text-[14px] mt-[20px]">
              Plan live sessions, workshops, and webinars, complete with
              engagement and management.
            </div>
          </div>
        </div>
      </div>
      <div className={styles.fifthLayerFrame}>
        <div className="w-full flex justify-center flex-col items-center">
          <div className="w-[40%] phone:w-full text-center text-white text-[40px] phone:text-[30px] font-bold leading-[120%]">
            Interact with Designs That Put You in Control
          </div>
          <div className="w-[70%] phone:w-full text-[18px] phone:text-[14px] text-white mt-4 text-center italic px-[80px] phone:px-0 leading-[150%]">
            Stay engaged with designs that streamline your learning process,
            keeping your team focused on achieving their goals.
          </div>
        </div>

        <div className="w-full phone:h-[233px]  flex justify-center ">
          <img
            src={
              isMobile
                ? "/images/landing-page-image/interact-designMobile.svg"
                : "/images/landing-page-image/interact-design.svg"
            }
            alt="interactive design"
            className="w-full h-[586px] phone:h-[233px] phone:mt-4 "
          />
        </div>
      </div>

      <div className={styles.sixthLayerFrame}>
        <div className="w-full text-center font-bold text-[40px] phone:text-[24px] leading-[120%] text-[#262626]">
          How Our Platform Transformed <br /> Training for Teams
        </div>
        <div className="w-full text-center mt-4 text-[#555555] text-[18px] phone:text-[14px] leading-[150%]">
          {`From startups to enterprises, our customers share how we've helped
          them optimize training and enhance learner engagement.`}
        </div>

        <div className="w-full phone:overflow-x-auto overflow-y-hidden h-[250px] mt-8 flex gap-8">
          <div className={styles.teamCard}>
            <div className="w-full h-[48px] flex">
              <img
                src="/images/landing-page-image/Avatar1.png"
                alt="avater"
                width={48}
                height={48}
              />
              <div className="ml-4">
                <div className="text-[20px] font-medium leading-[120%] text-[#262626]">
                  Lydia Fatima
                </div>
                <div className="text-[14px] leading-[150%] text-[#7B7B7B]">
                  Operations Manager
                </div>
              </div>
            </div>
            <div className=" phone:w-full text-[14px] leading-[150%] text-[#7B7B7B]">
              {`The video library and course manager features have been
              game-changers. Our employees can now access tailored training
              content anytime, which has boosted our team's productivity and
              learning outcomes.`}
            </div>
          </div>

          {!isMobile && (
            <div className={styles.teamCard}>
              <div className="w-full h-[48px] flex ">
                <img
                  src="/images/landing-page-image/CEOAvatar.svg"
                  alt="ceo Avater"
                  width={48}
                  height={48}
                />
                <div className="ml-4 phone:invisible phone:w-0 phone:h-0">
                  <div className="text-[20px] font-medium leading-[120%] text-[#262626]">
                    Malcom Victoria
                  </div>
                  <div className="text-[14px] leading-[150%] text-[#7B7B7B]">
                    CEO
                  </div>
                </div>
              </div>
              <div className="text-[14px] leading-[150%] text-[#7B7B7B] phone:invisible phone:w-0 phone:h-0">
                {`Our training programs became easier to manage, and our learners'
              engagement increased significantly. This platform helped us scale
              our learning initiatives with much more control.`}
              </div>
            </div>
          )}
          {!isMobile && (
            <div className={styles.teamCard}>
              <div className="w-full h-[48px] flex ">
                <img
                  src="/images/landing-page-image/HRAvatar.svg"
                  alt="hr avater"
                  width={48}
                  height={48}
                />
                <div className="ml-4">
                  <div className="text-[20px] font-medium leading-[120%] text-[#262626]">
                    James Peter
                  </div>
                  <div className="text-[14px] leading-[150%] text-[#7B7B7B]">
                    HR Leads
                  </div>
                </div>
              </div>
              <div className="text-[14px] leading-[150%] text-[#7B7B7B]">
                {` We transitioned from multiple platforms to this single solution
              and saw immediate improvements in both user management and content
              delivery. It’s an all-in-one tool that makes our work simpler.`}
              </div>
            </div>
          )}
        </div>
        {isMobile && (
          <div className="w-full mt-12 phone:mt-6 flex justify-center">
            <img
              src="/images/landing-page-image/horizontal-slide.svg"
              alt="slide"
              width={78}
              height={8}
            />
          </div>
        )}
      </div>

      <div className={styles.seventhLayerFrame}>
        <div className="w-[65%] phone:w-full h-full flex flex-col mt-10 ">
          <div className="w-[70%] phone:w-full text-[#262626] font-bold leading-[110%] text-[30px]">
            {`All-in-One Platform to Manage Your Users' `}
            <span className="text-[#663AC9]">Learning Experience</span>
          </div>
          <div className="w-[70%] phone:w-full mt-8 text-[18px] leading-[150%] text-[#555555]">
            With <span className=" italic text-[#EE2A7B]">MyEdVault,</span> you
            can seamlessly manage your users’ entire journey—organize courses,
            assign tasks, track progress, schedule events, and manage video
            content all in one powerful platform. Simplify user management and
            enhance engagement with our easy-to-use tools, designed to help your
            organization thrive.
          </div>
          <div className=" w-[40%] flex gap-6 mt-8 phone:w-full phone:flex phone:justify-center">
            <Button
              variant="landing-primary2"
              onClick={() => {
                router.push("/sign-up");
              }}
            >
              <p className="w-full px-5 py-4">Sign up</p>
            </Button>
            <Button
              variant="landing-secondary2"
              onClick={() => {
                router.push("/sign-in");
              }}
            >
              <p className="w-full px-5 py-4">Sign in</p>
            </Button>
          </div>
        </div>
        <div className="w-[35%] phone:w-full phone:h-auto h-full ">
          <img
            src="/images/landing-page-image/all-in-one.svg"
            alt="all in one"
            className="w-full h-full"
          />
        </div>
      </div>

      <AdminOnboardingBottomArea />
    </div>
  );
}

export default LandingPageBackground;
